/*
 * @Author: Tina Huang
 * @Date: 2023-02-06 20:15:35
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-02-06 23:36:56
 * @Description: global filters
 */

import moment from "moment";
moment.locale("zh-cn");
const relative = (timestamp = null) => {
  let _date = new Date(),
    _time = new Date().getTime();
  _date.setTime(timestamp);
  if (_time - parseInt(timestamp) > 30 * 24 * 60 * 60 * 1000) {
    return moment(
      `${_date.getFullYear()}-${
        _date.getMonth() + 1
      }-${_date.getDate()} ${_date.toLocaleTimeString()}`
    ).format("YYYY-MM-DD");
  }
  return moment(
    `${_date.getFullYear()}-${
      _date.getMonth() + 1
    }-${_date.getDate()} ${_date.toLocaleTimeString()}`
  ).fromNow();
};

const formatItemBtn = (item) => {
  if (item.close) {
    return item.advance ? "Coming soon" : "未开放分享";
  } else if (item.expired) {
    let isExpired = new Date() > new Date(item.expired);
    return isExpired ? "限时分享已结束" : "去创建";
  }
  return "去创建";
};

const formatItemBtnDisable = (item) => {
  if (item.close) {
    return true;
  } else if (item.expired) {
    let isExpired = new Date() > new Date(item.expired);
    return isExpired ? true : false;
  }
  return false;
};

export default {
  relative,
  formatItemBtn,
  formatItemBtnDisable,
};
